/* eslint-disable ember/no-runloop */
import Route from '@ember/routing/route';
import { next } from '@ember/runloop';

export default class ControlPanelRoute extends Route {
  model() {
    // The model needs to take until at least the next runloop to resolve, or
    // we get stuck on a white screen when home.index tries to transition to
    // this route (when the user clicks the Home icon) if we're already on it.
    return new Promise((resolve) => {
      next(this, resolve);
    });
  }
}
